
import SvgLinkedin from "../../assets/icons/svgLinkedin"
import Resume from "../../assets/files/CV - English.pdf"
import CV from "../../assets/files/CV.pdf"
import "./about.css"
import SvgGitHub from "../../assets/icons/svgGitHub"
import SvgMail from "../../assets/icons/svgMail"
import SvgFile from "../../assets/icons/svgFile"
import SvgPhone from "../../assets/icons/svgPhone"
import SvgLocation from "../../assets/icons/svgLocation"
import { useSelector } from "react-redux"



export default function AboutMe(){

  interface AppState{
    lenguage : string
  }
  
  let {lenguage} = useSelector((state: AppState) => state)

  if(lenguage === "english"){
    return (
      <div className="bigAboutContainer" >
        <div className="aboutTextContainer animate__animated animate__fadeInLeft" >
          <h2>
            About Me
          </h2>
        </div>
        <div className="aboutContainer">
          <div className="descriptionContainer animate__animated animate__fadeInUp">
            <h5>{"<Oleydi Peña />"} <b className="yellow">{"<Full Stack Web Developer/>"}</b></h5>
            <p>
              Hi! My name is Oleydi Peña and I am a passionate Full Stack Developer from Dominican Republic. I have experience working with JavaScript, TypeScript, NodeJS, Express, React, Redux, Next.js and SQL, among other technologies of the same nature. I can code a website from the ground up, Front or Back, including the database. I consider myself a proactive and creative individual with a positive attitude, strong organizational skills, a dynamic teamwork style, and strong problem-solving abilities. I also have a good handle of Git Flow, a wide capacity for learning, and a good level of english.</p>
          </div>
          <div className="aboutLinksContainer animate__animated animate__fadeInUp">
            <div className="aboutLinks">
              <SvgLinkedin className="aboutLinkIcon"/> 
              <div className="aboutLinkInfo">
                <h3>Linkedin:</h3> 
                <a href="https://www.linkedin.com/in/oleydi-pena-marte" target={"_blank"} rel="noreferrer">Oleydi Peña</a></div>
            </div>
            <div className="aboutLinks">
              <SvgGitHub className="aboutLinkIcon"/> 
              <div className="aboutLinkInfo">
                <h3>GitHub:</h3>
                <a href="https://github.com/oleydi1234" target={"_blank"} rel="noreferrer">oleydi1234</a>
              </div>
            </div>
            <div className="aboutLinks">
              <SvgMail className="aboutLinkIcon"/>
              <div className="aboutLinkInfo">
                <h3>Mail:</h3>
                <p>oleydi2@gmail.com</p>
              </div>
            </div>
            <div className="aboutLinks">
              <SvgPhone className="aboutLinkIcon"/>
              <div className="aboutLinkInfo">
                <h3>Phone:</h3>
                <p>+ 1 829-374-6421</p>
              </div> 
            </div>
            <div className="aboutLinks">
              <SvgFile className="aboutLinkIcon"/>
              <div className="aboutLinkInfo">
              <a href={Resume} download="Resume Oleydi Peña Full Stack Web Developer">
                <h3>Resume</h3>
              </a>
              </div> 
            </div>
            <div className="aboutLinks">
              <SvgLocation className="aboutLinkIcon"/> 
              <div className="aboutLinkInfo">
                <h3>Location:</h3>
                <p>DN - Santo Domingo</p>
              </div>
            </div>
          </div>
          <div className="educationAndExperienceContainer">
            <div className="bigAboutInfoContainer">
              <div className="aboutInfoContainer animate__animated animate__fadeInLeft">
                <h5>Experience</h5>
                <div className="aboutLineAndInfo">
                  <hr className="aboutInfoLine" />
                  <div>
                    <div className="aboutInfo">
                      <div className="infoTitle">
                        <div className="aboutPoint" />
                        <h6 className="infoTitleName">Pokemons App</h6>
                        <h6 className="infoTitleDate">Jan. 30 of 2023 - Feb. 14 of 2023</h6>
                      </div>
                      <p>Design and develop a pokemon app that included searches, filtering, ordering, and creation.</p>
                    </div>
                    <div className="aboutInfo">
                      <div className="infoTitle">
                        <div className="aboutPoint" />
                        <h6 className="infoTitleName">SOMOS CRACKS</h6>
                        <h6 className="infoTitleDate">Feb. 20 of 2023 - Mar. 24 of 2023</h6>
                      </div>
                      <p>Design and develop an innovative platform where players and scouts connect, which includes: Register, Login and creation of user profiles, Searches, Filtering by position and game styles, Sorting, Image upload, Notifications, Sending emails, Use of local storage, Player Dashboard, Headhunter Dashboard and Admin-Dashboard.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="aboutInfoContainer animate__animated animate__fadeInRight">
                <h5>Education</h5>
                <div className="aboutLineAndInfo">
                  <hr className="aboutInfoLine" />
                  <div>
                    <div className="aboutInfo">
                      <div className="infoTitle">
                        <div className="aboutPoint" />
                        <h6 className="infoTitleName">Henry Bootcamp</h6>
                        <h6 className="infoTitleDate">Nov. 07 of 2022 - Mar. 24 of 2023</h6>
                      </div>
                      <p>Full Stack Web Developer bootcamp. 700 hours of theoretical-practical course. <a href="https://certificates.soyhenry.com/new-cert?id=e91832aea88cbc7e0df8c078b6549c5caacad3cd78c9194d5abb9540dcfba524" target="_blank" rel="noreferrer" className="yellow">Certificate Link</a></p>
                    </div>
                    <div className="aboutInfo">
                      <div className="infoTitle">
                        <div className="aboutPoint" />
                        <h6 className="infoTitleName">Udemy Full-Stack path</h6>
                        <h6 className="infoTitleDate">Feb 01 of 2023 - Today</h6>
                      </div>
                      <p>3,594 hours of theoretical-practical course. <a href="#" target="_blank" rel="noreferrer" className="yellow">Certificate Link</a></p>
                    </div>
                    <div className="aboutInfo">
                      <div className="infoTitle">
                        <div className="aboutPoint" />
                        <h6 className="infoTitleName">Bachelor of Business Administration</h6>
                        <h6 className="infoTitleDate">September of 2011 - Feb. 02 of 2022</h6>
                      </div>
                      <p>University completed at UASD.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="aboutLenguageContainer animate__animated animate__fadeInUp">
            <h5>Lenguages</h5>
            <div className="aboutLineAndInfo">
              <hr className="aboutInfoLine" />
              <div>
                <div className="aboutInfo">
                  <div className="infoTitle">
                    <div className="aboutPoint" />
                    <h6 className="infoTitleName">English</h6>
                  </div>
                  <p>B1 - Intermediate. <a href="#" target="_blank" rel="noreferrer" className="yellow">Certificate Link</a></p>
                </div>
                <div className="aboutInfo">
                  <div className="infoTitle">
                    <div className="aboutPoint" />
                    <h6 className="infoTitleName">Spanish</h6>
                  </div>
                  <p>Native</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }else{
    return (
      <div className="bigAboutContainer" >
        <div className="aboutTextContainer animate__animated animate__fadeInLeft" >
          <h2>
            Sobre Mi
          </h2>
        </div>
        <div className="aboutContainer">
          <div className="descriptionContainer animate__animated animate__fadeInUp">
            <h5>{"<Oleydi Peña />"} <b className="yellow">{"<Full Stack Web Developer/>"}</b></h5>
            <p>
              Hola mi nombre es Oleydi Peña, soy una apasionada Full Stack Developer de República Dominicana, tengo experiencia trabajando con JavaScript, TypeScript, NodeJS, Express, React, Redux, Next.js y SQL, entre otras tecnologias del sector. Soy capaz de codear páginas web desde 0 tanto en Front cómo Back incluyendo la DB. Me considero una persona proactiva, creativa, con buena predisposición, grandes capacidades de organización y trabajo en equipo, buen manejo del Git Flow, resolución de problemas, amplia capacidad de aprendizaje y buen nivel de inglés.</p>
          </div>
          <div className="aboutLinksContainer animate__animated animate__fadeInUp">
            <div className="aboutLinks">
              <SvgLinkedin className="aboutLinkIcon"/> 
              <div className="aboutLinkInfo">
                <h3>Linkedin:</h3> 
                <a href="https://www.linkedin.com/in/oleydi-pena-marte" target={"_blank"} rel="noreferrer">Oleydi Peña</a></div>
            </div>
            <div className="aboutLinks">
              <SvgGitHub className="aboutLinkIcon"/> 
              <div className="aboutLinkInfo">
                <h3>GitHub:</h3>
                <a href="https://github.com/oleydi1234" target={"_blank"} rel="noreferrer">oleydi1234</a>
              </div>
            </div>
            <div className="aboutLinks">
              <SvgMail className="aboutLinkIcon"/>
              <div className="aboutLinkInfo">
                <h3>Mail:</h3>
                <p>oleydi2@gmail.com</p>
              </div>
            </div>
            <div className="aboutLinks">
              <SvgPhone className="aboutLinkIcon"/>
              <div className="aboutLinkInfo">
                <h3>Celular:</h3>
                <p>+ 1 829-374-6421</p>
              </div> 
            </div>
            <div className="aboutLinks">
              <SvgFile className="aboutLinkIcon"/>
              <div className="aboutLinkInfo">
              <a href={CV} download="Resume Oleydi Peña Full Stack Web Developer">
                <h3>Curriculum</h3>
              </a>
              </div> 
            </div>
            <div className="aboutLinks">
              <SvgLocation className="aboutLinkIcon"/> 
              <div className="aboutLinkInfo">
                <h3>Ubicación:</h3>
                <p>DN - Santo Domingo</p>
              </div>
            </div>
          </div>
          <div className="educationAndExperienceContainer">
            <div className="bigAboutInfoContainer">
              <div className="aboutInfoContainer animate__animated animate__fadeInLeft">
                <h5>Experiencia</h5>
                <div className="aboutLineAndInfo">
                  <hr className="aboutInfoLine" />
                  <div>
                    <div className="aboutInfo">
                      <div className="infoTitle">
                        <div className="aboutPoint" />
                        <h6 className="infoTitleName">Pokemons App</h6>
                        <h6 className="infoTitleDate">Ene. 30 del 2023 - Feb. 14 del 2023</h6>
                      </div>
                      <p>Diseñar y desarrollar una App de pokemons que incluía: búsquedas, filtrados, ordenamientos y creación.</p>
                    </div>
                    <div className="aboutInfo">
                      <div className="infoTitle">
                        <div className="aboutPoint" />
                        <h6 className="infoTitleName">SOMOS CRACKS</h6>
                        <h6 className="infoTitleDate">Feb. 20 del 2023 - Mar. 24 del 2023</h6>
                      </div>
                      <p>Diseño y desarrollo de una innovadora donde se conectan jugadores y cazatalentos, la cual incluye: Login y creación de perfiles de usuario, Busquedas, Filtrados por posicion y estilos de juegos, Ordenamientos, Subida de imagenes, Notificaciones, Envío de mails, Uso del local storage, Dashboard Jugador, Dashboard Cazatalentos y Admin-Dashboard.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="aboutInfoContainer animate__animated animate__fadeInRight">
                <h5>Educación</h5>
                <div className="aboutLineAndInfo">
                  <hr className="aboutInfoLine" />
                  <div>
                    <div className="aboutInfo">
                      <div className="infoTitle">
                        <div className="aboutPoint" />
                        <h6 className="infoTitleName">Henry Bootcamp</h6>
                        <h6 className="infoTitleDate">Nov. 07 del 2022 - Mar. 24 del 2023</h6>
                      </div>
                      <p>Full Stack Web Developer bootcamp. 700 horas de curso teórico-práctico. <a href="https://certificates.soyhenry.com/new-cert?id=e91832aea88cbc7e0df8c078b6549c5caacad3cd78c9194d5abb9540dcfba524" target="_blank" rel="noreferrer" className="yellow">Link del Certificado</a></p>
                    </div>
                    <div className="aboutInfo">
                      <div className="infoTitle">
                        <div className="aboutPoint" />
                        <h6 className="infoTitleName">Udemy Full-Stack path</h6>
                        <h6 className="infoTitleDate">Feb. 01 del 2023 - Hoy</h6>
                      </div>
                      <p>3,594 horas de curso teórico-práctico <a href="#" target="_blank" rel="noreferrer" className="yellow">Link del Certificado</a></p>
                    </div>
                    <div className="aboutInfo">
                      <div className="infoTitle">
                        <div className="aboutPoint" />
                        <h6 className="infoTitleName">Título de Grado de Administración de empresas</h6>
                        <h6 className="infoTitleDate">Septiembre del 2011 - Febrero 02 del 2022</h6>
                      </div>
                      <p>Universidad completada en la UASD.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="aboutLenguageContainer animate__animated animate__fadeInUp">
            <h5>Idiomas</h5>
            <div className="aboutLineAndInfo">
              <hr className="aboutInfoLine" />
              <div>
                <div className="aboutInfo">
                  <div className="infoTitle">
                    <div className="aboutPoint" />
                    <h6 className="infoTitleName">Ingles</h6>
                  </div>
                  <p>B1 - Intermediate. <a href="#" target="_blank" rel="noreferrer" className="yellow">Link del Certificado</a></p>
                </div>
                <div className="aboutInfo">
                  <div className="infoTitle">
                    <div className="aboutPoint" />
                    <h6 className="infoTitleName">Español</h6>
                  </div>
                  <p>Nativo</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
    
    
}